import { environment } from './../environments/environment';
import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SharedModule } from './shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireFunctionsModule } from 'angularfire2/functions';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { AuthGuard } from './_guards/index';

// PAGE COMPONENTS (Orders Module is Lazy Loaded -- OrdersComponent and NeworderComponent)
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AccountComponent } from './account/account.component';
import { ConfirmModalComponent, AlertModalComponent } from './_shared/index';
import { ModalComponent } from './modal/modal.component';
import { CustomStripeFormComponent } from './custom-stripe-form/custom-stripe-form.component';

@NgModule({
	imports: [
		NgxSpinnerModule,
		SharedModule,
		BrowserModule,
		BrowserAnimationsModule,
		AngularFireModule.initializeApp(environment.firebase),
		AngularFirestoreModule,
		AngularFireAuthModule,
		AngularFireFunctionsModule,
		AppRoutingModule
	],
	declarations: [
		AppComponent,
		LoginComponent,
		HeaderComponent,
		DashboardComponent,
		AccountComponent,
		CustomStripeFormComponent
	],
	providers: [
		AuthGuard
	],
	entryComponents: [ModalComponent, ConfirmModalComponent, AlertModalComponent],
	bootstrap: [AppComponent]
	
})
export class AppModule {}
